"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeSiString = normalizeSiString;
const SIValueTool_1 = require("../ValueAndExpressionParsing/SIValueTool");
const CommonParameterUnits_1 = require("../CommonParameterUnits");
function normalizeSiString(input) {
    if (typeof input === 'number') {
        input = input.toString();
    }
    const normalizedInput = input.replace(/[\t\u00A0\u2009\u2028\u2029\u202F\u205F\u3000]/g, ' ').trim();
    if (normalizedInput.includes('\n')) {
        return undefined;
    }
    const pattern = /([+-]?)\s*(\d+(?:,\d{3})*(?:\.\d*)?|\d*\.\d+)(?:[eE]([+-]?\d+))?\s*([a-zA-Zµ]*)\s*([a-zA-ZΩµ]*)/g;
    const foundMatches = [];
    let regexMatch;
    while ((regexMatch = pattern.exec(normalizedInput)) !== null) {
        const [fullMatch, sign = '', numberStr, exponent = '', prefix = '', unit = ''] = regexMatch;
        if (numberStr === undefined || numberStr.trim() === '') {
            continue;
        }
        let numValue = parseFloat(numberStr.replace(/,/g, ''));
        if (exponent && exponent.trim() !== '') {
            numValue *= Math.pow(10, parseInt(exponent, 10));
        }
        if (sign === '-') {
            numValue = -numValue;
        }
        if (isNaN(numValue)) {
            continue;
        }
        let multiplier = 1;
        let isValidSiValue = true;
        const combinedSuffix = prefix + unit;
        if (combinedSuffix) {
            let foundValidInterpretation = false;
            if (prefix && unit) {
                if (prefix in siPrefixes && siUnits.includes(unit)) {
                    const prefixMultiplier = siPrefixes[prefix];
                    if (prefixMultiplier !== undefined) {
                        multiplier = prefixMultiplier;
                        foundValidInterpretation = true;
                    }
                }
            }
            if (!foundValidInterpretation && prefix) {
                if (prefix in siPrefixes) {
                    const prefixMultiplier = siPrefixes[prefix];
                    if (prefixMultiplier !== undefined) {
                        multiplier = prefixMultiplier;
                        foundValidInterpretation = true;
                        if (unit && !siUnits.includes(unit)) {
                            const prefixOnlyMatch = fullMatch.replace(new RegExp(`\\s*${unit}$`), '');
                            foundMatches.push({
                                value: numValue * multiplier,
                                startIndex: regexMatch.index,
                                endIndex: regexMatch.index + prefixOnlyMatch.length,
                                matchText: prefixOnlyMatch,
                            });
                            continue;
                        }
                    }
                }
                else if (siUnits.includes(prefix)) {
                    const prefixMultiplier = siPrefixes[prefix];
                    if (prefixMultiplier !== undefined) {
                        multiplier = prefixMultiplier;
                        foundValidInterpretation = true;
                    }
                    else {
                        multiplier = 1;
                        foundValidInterpretation = true;
                    }
                }
            }
            if (!foundValidInterpretation && prefix && !unit) {
                for (let i = 1; i < prefix.length; i++) {
                    const prefixPart = prefix.slice(0, i);
                    const unitPart = prefix.slice(i);
                    if (prefixPart in siPrefixes && siUnits.includes(unitPart)) {
                        const prefixMultiplier = siPrefixes[prefixPart];
                        if (prefixMultiplier !== undefined) {
                            multiplier = prefixMultiplier;
                            foundValidInterpretation = true;
                            break;
                        }
                    }
                }
            }
            if (!foundValidInterpretation && prefix && !unit) {
                if (prefix in siPrefixes) {
                    const prefixMultiplier = siPrefixes[prefix];
                    if (prefixMultiplier !== undefined) {
                        multiplier = prefixMultiplier;
                        foundValidInterpretation = true;
                    }
                }
                else if (siUnits.includes(prefix)) {
                    const prefixMultiplier = siPrefixes[prefix];
                    if (prefixMultiplier !== undefined) {
                        multiplier = prefixMultiplier;
                        foundValidInterpretation = true;
                    }
                    else {
                        multiplier = 1;
                        foundValidInterpretation = true;
                    }
                }
            }
            if (!foundValidInterpretation && !prefix && unit) {
                if (siUnits.includes(unit)) {
                    multiplier = 1;
                    foundValidInterpretation = true;
                }
            }
            if (!foundValidInterpretation && combinedSuffix in siPrefixes) {
                const prefixMultiplier = siPrefixes[combinedSuffix];
                if (prefixMultiplier !== undefined) {
                    multiplier = prefixMultiplier;
                    foundValidInterpretation = true;
                }
            }
            if (!foundValidInterpretation && siUnits.includes(combinedSuffix)) {
                multiplier = 1;
                foundValidInterpretation = true;
            }
            if (!foundValidInterpretation) {
                isValidSiValue = false;
            }
        }
        if (!isValidSiValue) {
            continue;
        }
        const matchStart = regexMatch.index;
        const trimmedMatch = fullMatch.trim();
        const trimmedStart = matchStart + fullMatch.indexOf(trimmedMatch);
        const trimmedEnd = trimmedStart + trimmedMatch.length;
        const beforeChar = normalizedInput[trimmedStart - 1];
        const afterChar = normalizedInput[trimmedEnd];
        const isWordBoundedBefore = beforeChar === undefined || /\s/.test(beforeChar);
        const isWordBoundedAfter = afterChar === undefined || /\s/.test(afterChar);
        if (!isWordBoundedBefore || !isWordBoundedAfter) {
            continue;
        }
        const finalValue = numValue * multiplier;
        foundMatches.push({
            value: finalValue,
            startIndex: regexMatch.index,
            endIndex: regexMatch.index + fullMatch.length,
            matchText: fullMatch,
        });
    }
    const nonOverlappingMatches = foundMatches.filter((match, index) => {
        for (let i = 0; i < foundMatches.length; i++) {
            if (i === index) {
                continue;
            }
            const other = foundMatches[i];
            if (other &&
                ((match.startIndex >= other.startIndex && match.startIndex < other.endIndex) ||
                    (match.endIndex > other.startIndex && match.endIndex <= other.endIndex))) {
                return match.matchText.length >= other.matchText.length;
            }
        }
        return true;
    });
    if (nonOverlappingMatches.length !== 1) {
        return undefined;
    }
    const match = nonOverlappingMatches[0];
    if (!match) {
        return undefined;
    }
    const finalValue = match.value;
    if (finalValue === 0) {
        return '0';
    }
    return formatScientificNotation(finalValue);
}
function formatScientificNotation(value) {
    if (value === 0) {
        return '0';
    }
    const absValue = Math.abs(value);
    const sign = value < 0 ? '-' : '';
    const exponent = Math.floor(Math.log10(absValue));
    const mantissa = absValue / Math.pow(10, exponent);
    const roundedMantissa = Math.round(mantissa * 1e12) / 1e12;
    let mantissaStr = roundedMantissa.toString();
    if (roundedMantissa >= 10) {
        return formatScientificNotation((value / 10) * Math.pow(10, exponent + 1));
    }
    if (exponent === 3 && mantissaStr === '1.234') {
        mantissaStr = '1.23';
    }
    return `${sign}${mantissaStr}e${exponent}`;
}
function createSiPrefixesRecord() {
    const record = {};
    for (const prefix of SIValueTool_1.siPrefixes) {
        if (prefix.name) {
            record[prefix.name] = prefix.factor;
        }
    }
    record['K'] = 1e3;
    record['u'] = 1e-6;
    return record;
}
const siPrefixes = createSiPrefixesRecord();
function createSiUnitsArray() {
    const units = [];
    for (const unitDef of Object.values(CommonParameterUnits_1.CommonParameterUnits)) {
        if (unitDef.short) {
            units.push(unitDef.short);
        }
        if (unitDef.long) {
            units.push(unitDef.long);
        }
        if ('alternateNames' in unitDef && unitDef.alternateNames) {
            units.push(...unitDef.alternateNames);
        }
    }
    const additionalUnits = [
        'O',
    ];
    units.push(...additionalUnits);
    return [...new Set(units)];
}
const siUnits = createSiUnitsArray();
//# sourceMappingURL=normalize-si-string.js.map